export function generateNewId(array) {

    if (array.length === 0) {
        return 1;
    }

    var max = array.reduce(function (prev, current) {
        if (+current.id > +prev.id) {
            return current;
        } else {
            return prev;
        }
    });

    let newId = parseInt(max.id) + 1;
    return newId;
}

export function getReadableBarcode(barcode) {

    // const zeros_only = string => [...string].every(c => '0'.includes(c));
    // if (barcode.length > 18) {

    //     if (zeros_only(barcode.substring(0, barcode.length - 18))) {
    //         barcode = barcode.slice(barcode.length - 18)
    //     }
    // }

    return barcode;
}

export function truncate(input, length) {
    return input.substring(0, length);
}

export const findInCollectionById = (collection, id) => {
    for (const item of collection) {
        if (item.id === id) {
          return item;
        }
      }
}

export function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }


 export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  
export function pad(number) {
    if (number < 10) {
        return number = "0" + String(number);
    }
    else {
        return number = String(number);
    }
}

export function toLowerAndCapitalizeFirstLetter(string) {
    // Convert the string to lowercase first
    string = string.toLowerCase();
    
    // Then capitalize the first letter and concatenate with the rest of the string
    return string.charAt(0).toUpperCase() + string.slice(1);
  }